<template>
  <v-card class="max-limited-height">
    <v-toolbar dark color="secondary">
      <v-toolbar-title> Messages for <i>{{ chat.name }}</i> </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-row class="mx-0">
      <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="messages"
              :items-per-page="15"
              dense
              :loading="loading"
              class="mt-2 elevation-2"
          >
            <template v-slot:item.thumbnail="{ item }">
            <div>
              <a :href="item.attachment" target="_blank"><v-img :src="item.thumbnail"></v-img></a>
            </div>
          </template>

          <template v-slot:item.type="{ item }">
            <div v-if="item.type != 'Text'">
              <a :href="item.attachment" target="_blank">{{ item.type }}</a>
            </div>
            <div v-else>
              {{ item.type }}
            </div>
          </template>
          </v-data-table>
      </v-col>
    </v-row>
  </v-card>
</template>


<script>
import { MESSAGES_BY_CHAT } from "../../../../constants/graphql/client/chat"
import { YYYYMMDDTime_readable } from "@/lib/fancy_date";

export default {
  name: "ChatMessages",
  props: ["chat", ],
  data() { 
    return {
    messages: [],
    loading: true,
    headers: [
        { text: 'Sender', value: 'sender' },
        { text: 'Sender JID', value: 'senderJid' },
        { text: 'Text', value: 'text' },
        { text: 'Image', value: 'thumbnail' },
        { text: 'Date/Time', value: 'timestamp' },
        { text: 'Type', value: 'type' },
      ]
    }
  },
  methods: {
     formatDate(date) {
      if(!date) {
        return ''
      }
      return YYYYMMDDTime_readable(date);
    },
    close() {
      this.$emit("close");
    },
  },
  apollo: {
    messagesByChat: {
      query: MESSAGES_BY_CHAT,
      variables() {
        return {
          remoteJid: this.chat.jid,
          orderBy: "-timestamp"
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          this.loading = false;
          this.messages = response.data.messagesByChat.edges.map((item) => {
            return {
              text: item.node.text ? item.node.text : item.node.caption,
              senderJid: item.node.senderJid,
              timestamp: this.formatDate(item.node.timestamp),
              sender: item.node.sender,
              thumbnail: item.node.thumbnail,
              attachment: item.node.attachment,
              type: item.node.type,
            }
          });
        }
      }
    }
  }
}
</script>

